import {Stack, styled} from '@mui/material';

export const CustomBox = styled(Stack)`
	padding: 16px;
	border-radius: 8px;
	gap: 16px;

	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;
